import Button from "@material-ui/core/Button";
import React, { useEffect, useState, useCallback } from "react";
import {
  useRecordContext,
  TopToolbar,
  ReferenceField,
  TextField,
  Labeled,
  useDataProvider,
  showNotification,
  useShowController,
  FunctionField,
  Title,
} from "react-admin";
import marker from "assets/images/marker.svg";
import historyImage from "assets/images/history.svg";

import TitleBreadcrumb from "../../components/TitleBreadcrumb";
import _ from "lodash";
import { connect } from "react-redux";
import GoogleMapReact from "google-map-react";
import moment from "moment";
import { getDataFromJson } from "utils/tools";

import Nouislider, { Formatter } from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import "./assignment.scss";

//@ts-ignore
import { GridShowLayout, RaGrid } from "ra-compact-ui";
import { makeStyles, Typography } from "@material-ui/core";
import CustomTimelineBusServices from "./components/CustomTimelineBusServices";
import Marker from "./components/Marker";
import CustomArrayChipField from "./components/CustomArrayChipField";
import DriverWithPhoneField from "./components/DriverWithPhoneField";
import StatusField from "../../components/StatusField";
import TypeField from "../../components/TypeField";
import AutorenewIcon from "@material-ui/icons/Autorenew";

interface IStatusParser {
  [x: string]: {
    status: string;
    notificationText: string;
    notificationErrorText: string;
  };
}

const useStyles = makeStyles({
  detailAssignment: {
    padding: "10px 20px",
  },
  titleAssignment: {
    marginLeft: "16px !important",
    marginBottom: "-60px !important",
  },
  wrapper: {
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    boxShadow: "0 4px 8px rgb(0 0 0 / 3%)",
    marginBottom: 12,
  },
  childWrapper: {
    backgroundColor: "#FAFAFA",
    borderRadius: 10,
    boxShadow: "0 4px 8px rgb(0 0 0 / 3%)",
  },
  actionReady: {
    backgroundColor: "#4caf50",
  },
  actionStarted: {
    backgroundColor: "#1976d2",
  },
  actionEnded: {
    backgroundColor: "#7c4dff",
  },
  actionCancel: {
    backgroundColor: "#f44336",
  },
  actionAssign: {
    backgroundColor: "#ffd600",
    color: "#000",
  },
  bottonShowMap: {
    marginBottom: 20,
  },
});

const statusParser: IStatusParser = {
  cancel: {
    status: "cancelled",
    notificationText: "Assignment Cancelled",
    notificationErrorText: "Cannot cancel assignment, please try again.",
  },
  start: {
    status: "started",
    notificationText: "Assignment Started",
    notificationErrorText: "Cannot start assignment, please try again.",
  },
  end: {
    status: "ended",
    notificationText: "Assignment Finished",
    notificationErrorText: "Cannot finish assignment, please try again.",
  },
  ready: {
    status: "ready",
    notificationText: "Assignment set to Ready",
    notificationErrorText: "Cannot set ready assignment, please try again.",
  },
};

/**
 * Action buttons for Order Show
 *
 * @param param0
 */
const OrderShowActions = connect(undefined, { showNotification })(
  ({ history, record, ...props }: any) => {
    const provider = useDataProvider();
    const classes = useStyles();

    const _changeStatus = async (to: string) => {
      const { id, driverId, vehicleId } = record;
      const data =
        to === "start" ? { driverId, vehicleId, driverType: "driver" } : {};

      try {
        await provider.customUpdate(`assignments/${id}/${to}`, {
          id,
          data,
        });

        props.showNotification(statusParser[to].notificationText);
        setTimeout(() => {
          window.location.reload();
        }, 200);
      } catch (error: any) {
        props.showNotification(
          `${statusParser[to].notificationErrorText} Error Message : ${error.message}`,
          "warning"
        );
      }
    };

    return (
      <TopToolbar>
        <Button
          color="primary"
          variant="contained"
          onClick={() => history.push(`/assignments/${record.id}/edit`)}
          className={classes.actionAssign}
        >
          Assign/Unassign
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => _changeStatus("ready")}
          className={classes.actionReady}
        >
          Set Ready
        </Button>

        <Button
          color="primary"
          variant="contained"
          onClick={() => _changeStatus("cancel")}
          className={classes.actionCancel}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => _changeStatus("start")}
          className={classes.actionStarted}
        >
          Start
        </Button>

        <Button
          color="primary"
          variant="contained"
          onClick={() => _changeStatus("end")}
          className={classes.actionEnded}
        >
          End
        </Button>
      </TopToolbar>
    );
  }
);

const CustomShow = (props: any) => {
  const {
    basePath, // deduced from the location, useful for action buttons
    // defaultTitle, // the translated title based on the resource, e.g. 'Post #123'
    // loaded, // boolean that is false until the record is available
    // loading, // boolean that is true on mount, and false once the record was fetched
    record, // record fetched via dataProvider.getOne() based on the id from the location
    resource, // the resource name, deduced from the location. e.g. 'posts'
    version, // integer used by the refresh feature
  } = useShowController(props);
  const classes = useStyles();

  const formatter = (data: any) => {
    if (data) {
      data.estimatedStartAt = moment(data.estimatedStartedAt).format(
        "DD / MM / YYYY, hh:mm A"
      );
      data.estimatedEndAt = moment(data.estimatedEndedAt).format(
        "DD / MM / YYYY, hh:mm A"
      );
      data.startAt = data.startedAt
        ? moment(data.startedAt).format("DD / MM / YYYY, hh:mm A")
        : "-";
      data.endAt = data.endedAt
        ? moment(data.endedAt).format("DD / MM / YYYY, hh:mm A")
        : "-";

      data.subcontractorStartDate = data.assignedSubcontractor?.startDate
        ? moment(data.assignedSubcontractor?.startDate).format("DD / MM / YYYY")
        : "-";
      data.subcontractorEndDate = data.assignedSubcontractor?.endDate
        ? moment(data.assignedSubcontractor?.endDate).format("DD / MM / YYYY")
        : "-";

      data.startTime = moment(data.estimatedStartedAt).format("hh:mm A");
      data.endTime = moment(data.estimatedEndedAt).format("hh:mm A");

      data.takingCount = 0;
      data.absentCount = 0;
      data.notTakingCount = 0;
      data.totalCount = 0;

      if (data.locations) {
        data.locations.forEach((location: any, index: number) => {
          // convert ASCII Code into Alphabet
          // 65 === A
          const locationCode = String.fromCharCode(65 + index);

          location.arrivAt = moment(location.estimatedArrivedAt).format(
            "hh:mm A"
          );
          location.departAt = moment(location.departedAt).format("hh:mm A");

          location.passengers
            .sort((a: any, b: any) => a.id - b.id)
            .forEach((passenger: any, index: number) => {
              passenger.locationCode = `${locationCode}${index + 1}`;

              data.totalCount += 1;
              if (passenger.logs.length > 0) {
                const sortedLogs = _.orderBy(
                  passenger.logs,
                  ["loggedAt"],
                  ["desc"]
                );

                if (
                  sortedLogs[0].type === "boarded" ||
                  sortedLogs[0].type === "alighted"
                ) {
                  data.takingCount += 1;

                  if (sortedLogs[0].type === "boarded") {
                    passenger.status = "ON THE BUS";
                  } else {
                    passenger.status = "ALIGHT";
                  }
                }

                if (sortedLogs[0].type === "absented") {
                  data.absentCount += 1;
                  passenger.status = "ABSENT";
                }

                if (sortedLogs[0].type === "not_taking") {
                  data.notTakingCount += 1;
                  passenger.status = "NOT TAKING";
                }

                if (sortedLogs[0].type === "exclude_student") {
                  data.notTakingCount += 1;
                  passenger.status = "EXCLUDE STUDENT";
                }
              } else {
                passenger.status = "NOT STARTED";
              }
            });
        });
      }
    }

    return data;
  };
  return (
    <div>
      <Typography
        variant="h4"
        className={classes.titleAssignment}
      >{`Bus Services - ${record?.routeName}`}</Typography>

      <Title title={`Bus Services - ${record?.routeName}`} />

      {React.cloneElement(props.children, {
        basePath,
        record: formatter(record),
        resource,
        version,
      })}
    </div>
  );
};

/**
 * Display details of orders
 * @param props
 */
const AssignmentShow = (props: any) => {
  const { history } = props;
  const classes = useStyles();
  const [isShowMap, setIsShowMap] = useState(true);

  const breadcrumbPaths = [
    { link: "/assignments", title: "Bus Services" },
    { link: `/assignments/${props.id}/show`, title: props.id },
  ];

  return (
    <>
      <TitleBreadcrumb paths={breadcrumbPaths} />
      <CustomShow {...props}>
        <GridShowLayout>
          <OrderShowActions history={history} {...props} />

          <RaGrid container>
            <RaGrid item xs={12} className={classes.wrapper}>
              <RaGrid container className={classes.detailAssignment}>
                <RaGrid item xs={4}>
                  <Labeled label="Assignment Date">
                    <TextField source="estimatedStartAt" emptyText="-" />
                  </Labeled>
                  <Labeled label="Start At">
                    <TextField source="startAt" emptyText="-" />
                  </Labeled>
                  <Labeled label="End At">
                    <TextField source="endAt" emptyText="-" />
                  </Labeled>
                  <Labeled label="Route Type">
                    <TypeField source="routeType" type="busSchedule" />
                  </Labeled>
                </RaGrid>

                <RaGrid item xs={4}>
                  <Labeled label="Assignment Status">
                    <StatusField source="status" />
                  </Labeled>

                  <Labeled label="All Students">
                    <FunctionField
                      render={(record: any) => (
                        <>
                          <Typography variant="subtitle2">
                            {record.takingCount} / {record.totalCount}
                          </Typography>
                        </>
                      )}
                    />
                  </Labeled>

                  <Labeled label="Absent">
                    <TextField source="absentCount" emptyText="-" />
                  </Labeled>

                  <Labeled label="Not Taking">
                    <TextField source="notTakingCount" emptyText="-" />
                  </Labeled>
                </RaGrid>

                <RaGrid item xs={4}>
                  <ReferenceField
                    label="Assigned Vehicle"
                    source="vehicleId"
                    reference="vehicles"
                    linkType="show"
                    emptyText="-"
                  >
                    <TextField source="plateNumber" />
                  </ReferenceField>

                  <ReferenceField
                    label="Assigned Driver"
                    source="driverId"
                    reference="drivers"
                    linkType="show"
                  >
                    <DriverWithPhoneField />
                  </ReferenceField>

                  <ReferenceField
                    label="Assigned Bus Assistant"
                    source="busAssistantId"
                    reference="busAssistants"
                    linkType="show"
                  >
                    <DriverWithPhoneField />
                  </ReferenceField>

                  <Labeled label="Backup Drivers">
                    <CustomArrayChipField
                      source="backupDrivers"
                      chipSource="fullName"
                    />
                  </Labeled>

                  <Labeled label="Backup Vehicles">
                    <CustomArrayChipField
                      source="backupVehicles"
                      chipSource="plateNumber"
                    />
                  </Labeled>

                  <Labeled label="Backup Bus Assistants">
                    <CustomArrayChipField
                      source="backupBusAssistants"
                      chipSource="fullName"
                    />
                  </Labeled>
                </RaGrid>
              </RaGrid>
            </RaGrid>

            <RaGrid item xs={12} className={classes.wrapper}>
              <RaGrid container className={classes.detailAssignment}>
                <Typography variant="h6">Bus Services Detail</Typography>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    setIsShowMap(!isShowMap);
                  }}
                  startIcon={<AutorenewIcon />}
                >
                  {isShowMap ? "Hide Map" : "Show Map"}
                </Button>
                <RaGrid container>
                  <RaGrid item lg={isShowMap ? 5 : 12} md={12} xs={12}>
                    <CustomTimelineBusServices
                      source="locations"
                      assignmentId={props.id}
                    />
                  </RaGrid>
                  {isShowMap ? (
                    <RaGrid item lg={7} md={12} xs={12}>
                      <Maps resource />
                    </RaGrid>
                  ) : (
                    <></>
                  )}
                </RaGrid>
              </RaGrid>
            </RaGrid>
          </RaGrid>
        </GridShowLayout>
      </CustomShow>
    </>
  );
};

const Maps = ({ ...props }: any) => {
  const record = useRecordContext(props);
  const [mapInstance, setMapInstance] = useState<any>(null);
  const [mapsLayoutInstance, setMapsLayout] = useState<any>(null);
  const [markerLocation, setMarkerLocation] = useState({ Lat: 0, Lng: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [tripHistory, setTripHistory] = useState([]);

  useEffect(() => {
    if (record) {
      if (record.tripHistoryUrl) {
        setIsLoading(true);
        getDataFromJson(record.tripHistoryUrl).then((res: any) => {
          setTripHistory(res.json);
          setIsLoading(false);
        });
      }
    }
  }, [record]);

  useEffect(() => {
    if (mapInstance !== null && mapsLayoutInstance !== null) {
      tripHistory.forEach((item: any, index: number) => {
        let path = null;
        if (index !== 0) {
          const prevItem = tripHistory[index - 1];
          path = [
            { lat: Number(prevItem.Lat), lng: Number(prevItem.Lng) },
            { lat: Number(item.Lat), lng: Number(item.Lng) },
          ];
          const line = new mapsLayoutInstance.Polyline({
            path,
            strokeColor: "#ff5722",
          });
          line.setMap(mapInstance);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapInstance, mapsLayoutInstance]);

  const handleApiLoaded = useCallback(
    (map: any, maps: any) => {
      // use map and maps objects

      setMapInstance(map);
      setMapsLayout(maps);
    },
    [setMapInstance, setMapsLayout]
  );

  const renderMarker = useCallback((record) => {
    if (record) {
      if (record.locations) {
        return record.locations.map((item: any) => {
          return <Marker lat={item.lat} lng={item.lng} resource={item} />;
        });
      }
    }
  }, []);

  const renderSchoolMarker = useCallback((record) => {
    if (record) {
      if (record.school) {
        return (
          <Marker
            lat={record.school.lat}
            lng={record.school.lng}
            resource={record.school}
            isSchool
          />
        );
      }
    }
  }, []);

  const onSliderUpdate = useCallback(
    (index: any) => {
      if (tripHistory.length !== 0) {
        const item = tripHistory[Number(index)];
        setMarkerLocation({
          Lat: item.Lat,
          Lng: item.Lng,
        });
      }
    },
    [tripHistory]
  );

  const rangeFormatter = useCallback(
    (value: any) => {
      if (tripHistory[value]) {
        return moment(tripHistory[value].CreatedAt).format(
          "DD / MM / YYYY hh:mm A"
        );
      }
      return "";
    },
    [tripHistory]
  );

  const tooltip: Formatter = {
    from: Number,
    to: (value: number): string => {
      if (tripHistory[Number(value)]) {
        const item = tripHistory[Number(value)];
        return `Latitude: ${item.Lat}\n\n Longitude: ${
          item.Lng
        } \n\n Time: ${moment(item.CreatedAt).format(
          "DD / MM / YYYY hh:mm A"
        )}`;
      }
      return "";
    },
  };

  if (tripHistory.length === 0) {
    return (
      <div className="TripHistoryContainer">
        {isLoading ? (
          <p className="TripHistory-Indicator">Loading trip history data...</p>
        ) : (
          <>
            <img
              className="TripHistory-Icon"
              src={historyImage}
              alt="History Not Found"
            />
            <p className="TripHistory-Indicator">
              Trip history not available, try again later.
            </p>
          </>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="TripHistoryContainer">
        <GoogleMapReact
          bootstrapURLKeys={{
            key: "AIzaSyDYGvy_HvsUfvJ_7_d4PmOH201jIFNn-iM",
          }}
          defaultCenter={{
            lat: 1.415039,
            lng: 103.807996,
          }}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
          defaultZoom={13}
        >
          {renderMarker(record)}
          {renderSchoolMarker(record)}
          <BusMarker lat={markerLocation.Lat} lng={markerLocation.Lng} />
        </GoogleMapReact>
      </div>
      {tripHistory.length > 1 && (
        <Nouislider
          style={{
            marginLeft: 50,
            marginRight: 50,
            marginBottom: 50,
            marginTop: 20,
          }}
          onUpdate={onSliderUpdate}
          step={1}
          pips={{
            mode: "range",
            density: 2,
            format: {
              to: rangeFormatter,
            },
          }}
          range={{
            min: 0,
            max: tripHistory.length - 1,
          }}
          start={0}
          tooltips={[tooltip]}
          connect
        />
      )}
    </>
  );
};

const BusMarker = (props: any) => {
  return (
    <div className="Marker-Wrapper">
      <img className="Marker-Icon" src={marker} alt="Bus Marker" />
    </div>
  );
};
export default AssignmentShow;
